<template>
  <div id="fazWahlDashboard" v-if="loaded">
    <select v-model="stage" v-if="false" style="position: absolute; width: 100px;">
      <option>empty</option>
      <option>trend</option>
      <option>vorl</option>
      <option>endg</option>
    </select>
    <div class="headline">Kommunalwahl in Hessen</div>
    <div class="subheadline">{{stageString}}<span v-if="date"> · {{date}}</span></div>
    <div class="grid-x align-center relative" v-if="true">
      <div class="cell small-6 medium-3">
        <div class="radio left">
          <input type="radio" id="gemeindewahl" value="Gemeindewahl" v-model="election">
          <label for="gemeindewahl"> Gemeinden  </label>
          <input type="radio" id="kreiswahl" value="Kreiswahl" v-model="election">
          <label for="kreiswahl"> Kreise</label>
        </div>
      </div>
      <div class="cell small-6 medium-2">
        <div class="radio">
          <input type="radio" id="2016" value="2016" v-model="year">
          <label for="2016"> 2016 </label>
          <input type="radio" id="2021" value="2021" v-model="year">
          <label for="2021"> 2021</label>
        </div>
      </div>
      <div class="cell small-12 medium-5">
        <div class="regionSelect">
          <multiselect 
            v-model="selectedRegion" 
            :options="activeData" 
            :show-labels="false" 
            :placeholder="regionSelectPlaceholder"
            track-by="GKZ"
            label="Gemeinde"
            @select="select">
          </multiselect>
        </div>
      </div>
    </div>
    
    <div class="grid-x grid-margin-x relative" v-if="true">
      <div class="cell small-12 medium-6">
        <div class="chartWrapper">
          <div class="chartWrapper_headline" v-if="election=='Gemeindewahl'">Stärkste Partei in den Gemeinden</div>
          <div class="chartWrapper_headline" v-else>Stärkste Partei in den Kreisen</div>
          <!-- <div class="chartWrapper_subheadline">in den Gemeinden</div> -->
          <select v-model="mapView" class="dropdown">
            <option>Stärkste Partei</option>
            <option v-for="party in parties" v-bind:key="party.label">{{party.label}}</option>
          </select>
          <Map 
            :geoJson="choroplethMap"
            :geoJsonSupraregional="regionMap"
            :data="mapData"
            :settings="mapSettings"
            :regionKey="'AGS'"
            :regionName="'GEN'"
            v-model="selectedRegion"
            :markers="cities"
            :year="year"
          />
          <!--  v-model="hover" -->
        </div>
      </div>
      <div class="cell small-12 medium-6">
        <div class="chartWrapper">
          <div class="chartWrapper_headline">Stimmenverteilung</div>
          <div class="chartWrapper_subheadline" v-if="!selectedRegion">Gesamtergebnis Hessen</div>
          <div class="chartWrapper_subheadline" v-else>in <b>{{selectedRegion.Gemeinde}}</b></div>
          <ColumnChart 
            :data="stimmenverteilung"
            :colors="parties2021"
            :height="150"
            :suffix="'%'"
            :baseline="true"
          />
          <div class="footnote" v-if="selectedRegion">
            <span v-if="selectedRegion.Wahlbeteiligung>0">
              Wahlbeteiligung: {{String(selectedRegion.Wahlbeteiligung).replace('.',',')}}%
            </span>
            <span v-if="selectedRegion.Auszaehlungsstand>0">
              / Auszählungsstand: {{String(selectedRegion.Auszaehlungsstand).replace('.',',')}}%
            </span>
          </div>
          <div class="footnote" v-else>
            <span v-if="dataHessen.find(row => row.Jahr == year).Wahlbeteiligung>0">
              Wahlbeteiligung: {{String(dataHessen.find(row => row.Jahr == year).Wahlbeteiligung).replace('.',',')}}%
            </span>
            <span v-else>
              Es ist noch kein Gesamtergebnis vorhanden
            </span>
          </div>
        </div>
        <div class="chartWrapper" v-if="year=='2016'||stage!='trend'">
          <div class="chartWrapper_headline">Sitze</div>
          <!-- <div class="chartWrapper_subheadline"></div> -->
          <SeatChart 
            :data="sitzverteilung"
            :colors="parties"
            :legend="true"
          />
        </div>
        <div class="chartWrapper" v-if="year!='2016'&&stage!='empty'">
          <div class="chartWrapper_headline">Gewinne und Verluste</div>
          <div class="chartWrapper_subheadline">im Vergleich zu 2016, in Prozentpunkten</div>
          <ColumnChart 
            :data="gewinneVerluste"
            :colors="parties"
            :plusminus="true"
            :height="150"
            :baseline="true"
          />
        </div>
      </div>
    </div>
    <div class="footnote">
      <span v-if="stage=='trend'">Trendergebnisse bilden lediglich einen Teil der ausgezählten Stimmen ab. Berücksichtigt sind nur die Stimmzettel, bei denen ein Wahlvorschlag unverändert angenommen wurde.<br></span>
      Grafik:&nbsp;Giesel / Quelle:&nbsp;Hessisches Statistisches Landesamt</div>
    <barsLayout v-if="env != 'production'&&true"
      :data="stimmenverteilungenKreise2"
      :parties="parties2021"
    />
    <kreiseXML v-if="env != 'production'&&true"
      :kreise="rheinMainKreise" 
      :gemeinden="stimmenverteilungenGemeinden" 
    />
  </div>
</template>

<script>
import Map from './components/Map.vue'
import ColumnChart from './components/ColumnChart.vue'
import SeatChart from './components/SeatChart.vue'
import barsLayout from './components/barsLayout.vue'
import kreiseXML from './components/kreiseXML.vue'

import {csvParse } from 'd3' //, format
import * as d3 from 'd3'
import Multiselect from 'vue-multiselect'

export default {
  name: 'app',
  components: {
    Map,
    ColumnChart,
    SeatChart,
    barsLayout,
    kreiseXML,
    Multiselect
  },
  data () {
    return {
      env: process.env.NODE_ENV,
      loaded: false,
      stage: "trend",
      date: null,
      dataGemeinden2016: null,
      dataLandkreise2016: null,
      dataGemeinden2021: null,
      dataLandkreise2021: null,
      dataHessen: null,
      gemeindenMap: null,
      kreiseMap: null,
      mapView: "Stärkste Partei",
      election: "Gemeindewahl",
      year: "2021",
      selectedRegion: null,
      parties: [ 
        {label: "CDU", id: "CDU", color: "#111111"},
        {label: "SPD", id: "SPD", color: "#c51d1e"},
        {label: "Grüne", id: "GRÜNE", color: "#0c9941"},
        {label: "Linke", id: "DIE LINKE", color: "#bb4894"},
        {label: "FDP", id: "FDP", color: "#f6c909"},
        {label: "AfD", id: "AfD", color: "#2b7ab4"},
        // {label: "FW", id: "FREIE WÄHLER", color: "#F59C04"},
      ],
      parties2021: [ 
        {label: "CDU", id: "CDU", color: "#111111"},
        {label: "SPD", id: "SPD", color: "#c51d1e"},
        {label: "Grüne", id: "GRÜNE", color: "#0c9941"},
        {label: "Linke", id: "DIE LINKE", color: "#bb4894"},
        {label: "FDP", id: "FDP", color: "#f6c909"},
        {label: "Piraten", id: "PIRATEN", color: "#f39200"},
        {label: "REP", id: "REP", color: "#a07e26"},
        {label: "NPD", id: "NPD", color: "#a07e26"},
        {label: "AfD", id: "AfD", color: "#2b7ab4"},
        {label: "Alfa", id: "ALFA", color: "#88a3d6"},
        {label: "Einheit", id: "EINHEIT", color: "#a284c7"},
        {label: "FW", id: "FREIE WÄHLER", color: "#b5b9bc"},
        {label: "Volt", id: "Volt", color: "#502379"},
        {label: "Humanisten", id: "HUMANISTEN", color: "#d90368"},

        {label: "Die PARTEI", id: "Die PARTEI", color: "#B92837"},
        {label: "DKP", id: "DKP", color: "red"},
        {label: "Bündnis C", id: "Bündnis C", color: "#0070b9"},
        {label: "dieBasis", id: "dieBasis", color: "#159733"},

        {label: "BIG", id: "BIG", color: "#b5b9bc"},
        {label: "APPD", id: "APPD", color: "#b5b9bc"},
        {label: "LKR", id: "LKR", color: "#b5b9bc"},
        {label: "Tierschutzpartei", id: "Tierschutzpartei", color: "#b5b9bc"},

        {label: "WG", id: "Wählergruppen", color: "#b5b9bc"},
        {label: "WG1", id: "WG1", color: "#b5b9bc"},
        {label: "WG2", id: "WG2", color: "#b5b9bc"},
        {label: "WG3", id: "WG3", color: "#b5b9bc"},
        {label: "WG4", id: "WG4", color: "#b5b9bc"},
        // {label: "Sonst.", id: "sonst", color: "lightgrey"}
      ],
      kreisfreieStaedte: ["611000", "411000", "412000", "413000", "414000"],
      rheinMain: ["435", "440", "432", "436", "438", "434", "439", "433", "611", "411", "412", "413", "414"],
      kreise: [633, 611000, 635, 634, 636, 632, 534, 535, 631, 532, 531, 533, 434, 440, 435, 439, 414000, 436, 412000, 413000, 438, 433, 411000, 432, 431, 437],
      cities: [
        {label: 'Kassel', long: '51.3061372', lat: '9.4817461', anchor: 'middle'},
        {label: 'Frankfurt', long: '50.1013195', lat: '8.653302', anchor: 'middle'},
        {label: 'Wiesbaden', long: '50.0799712', lat: '8.2447214', anchor: 'end'},
        {label: 'Darmstadt', long: '49.8700781', lat: '8.653302', anchor: 'middle'},
        {label: 'Limburg', long: '50.3910611', lat: '8.0690929', anchor: 'middle'},
        {label: 'Fulda', long: '50.5527662', lat: '9.6865473', anchor: 'middle'},
        {label: 'Bad Hersfeld', long: '50.8670035', lat: '9.7084843', anchor: 'middle'},
        {label: 'Marburg', long: '50.8054883', lat: '8.7661042', anchor: 'middle'},
        {label: 'Gießen', long: '50.5849266', lat: '8.6741387', anchor: 'middle'},
      ],
      emptyData: {
        "cols":[
          {"label":"","id":"a","color":"#dfdfdf"},
          {"label":"","id":"b","color":"#cfcfcf"},
          {"label":"","id":"c","color":"#efefef"},
        ],
        "rows":[[3,2,1]]
      }
    }
  },
  watch: {
    election: function () {
      this.selectedRegion = null
    }
  },
  computed: {
    stageString () {
      switch (this.stage) {
        case "empty":
          return 'Trendergebnisse ab 19:30'
        case "trend":
          return "Trendergebnisse"
        case "vorl":
          return "Vorläufige Ergebnisse"
        case "endg":
          return "Endgültige Ergebnisse"
        default:
          return "Trendergebnisse"
      }
    },
    regionSelectPlaceholder () {
      return this.election == "Gemeindewahl" ? "Gemeinde suchen" : "Landkreis / kreisfreie Stadt suchen"
    },
    activeParty () {
      return this.parties2021.find( party => party.label == this.mapView)
    },
    activeData () {
      return this.year == "2016" ?
        this.election == "Gemeindewahl" ? 
          this.dataGemeinden2016 : this.dataLandkreise2016
      : this.election == "Gemeindewahl" ? 
        this.dataGemeinden2021 : this.dataLandkreise2021
    },
    choroplethMap () {
      return this.election == "Gemeindewahl" ? 
        this.gemeindenMap : this.kreiseMap
    },
    regionMap () {
      return this.election == "Gemeindewahl" ? 
        this.kreiseMap : null
    },
    mapData () {
      if(this.stage=='empty'&&this.year!='2016') { return [] }

      let result = []
      if (this.mapView == "Stärkste Partei") {
        result = this.activeData.map ( (region) => {
          let prozente = this.sortParties(region, 100, false)
          let winner = prozente[0]

          return {
            regionKey: '06'+region.GKZ,
            regionName: region.Gemeinde,
            Wahlbeteiligung: region.Wahlbeteiligung,
            Auszaehlungsstand: region.Auszaehlungsstand,
            category: winner ? winner.id : 'No Data',
            tooltip: prozente
              .map ( party => `${party.label}: ${String(party.percent).replace('.',',')}%` )
          }
        })
      } else {
        result = this.activeData.map ( region => {
          return {
            regionKey: '06'+region.GKZ,
            regionName: region.Gemeinde,
            Wahlbeteiligung: region.Wahlbeteiligung,
            Auszaehlungsstand: region.Auszaehlungsstand,
            value: region[this.activeParty.id],
            tooltip: this.sortParties(region, 100, false)
              .map ( party => `${party.label}: ${String(party.percent).replace('.',',')}%` )
          }
        })
      }

      let nodata = [
        {
          "regionKey":"06435200",
          "regionName":"Gutsbezirk Spessart",
          "category":"nodata",
          "tooltip":["keine Wahl"]
        },
        {
          "regionKey":"06633200",
          "regionName":"Gutsbezirk Reinhardswald",
          "category":"nodata",
          "tooltip":["keine Wahl"]
        },
        {
          "regionKey":"06636200",
          "regionName":"Gutsbezirk Kaufunger Wald",
          "category":"nodata",
          "tooltip":["keine Wahl"]
        }
      ]

      return [...result, ...nodata]
    },
    mapSettings () {
      if (this.mapView == "Stärkste Partei") {
        return {
          title: "Stärkste Partei",
          type: "category",
          regionKey: 'AGS',
          colors: this.parties2021,
          suffix: "%",
          legend: false
        }
      } else {
        return {
          title: "Stimmenanteil " + this.mapView,
          type: "heatmap",
          regionKey: 'AGS',
          colors: this.parties2021,
          suffix: "%",
          legend: true,
          // domain: [0,50], // optional
          range: ['#efefef', this.activeParty.color]
        }
      }
    },
    stimmenverteilung () {
      if(this.stage=='empty'&&this.year!='2016') { return this.emptyData}

      let region = null
      if (this.selectedRegion) {
        region = this.activeData.find( region => region.GKZ == this.selectedRegion.GKZ)
      } else {
        region = this.dataHessen.find( data => data.Jahr == this.year )
      }

      let result = this.sortParties(region, 6, true)
      
      return {
        cols: result,
        rows: [ result.map( party => party.percent) ]
      }
    },
    gewinneVerluste () {
      let region = null
      if (this.selectedRegion) {
        region = this.activeData.find( region => region.GKZ == this.selectedRegion.GKZ)
      } else {
        region = this.dataHessen.find( data => data.Jahr == this.year )
      }

      let regionOld = null
      if (this.selectedRegion) {
        if (this.election == "Gemeindewahl") {
          regionOld = this.dataGemeinden2016.find( region => region.GKZ == this.selectedRegion.GKZ)
        } else {
          regionOld = this.dataLandkreise2016.find( region => region.GKZ == this.selectedRegion.GKZ)
        }
      } else {
        regionOld = this.dataHessen.find( data => data.Jahr == '2016' )
      }

      let result = this.sortParties(region, 6, true, regionOld).filter( a => a.percentOld >= 0)

      return {
        cols: result,
        rows: [ result.map( party => party.diff), result ]
      }
    },
    sitzverteilung () {
      if(this.stage=='empty'&&this.year!='2016') { return this.emptyData}

      let region = null
      if (this.selectedRegion) {
        region = this.activeData.find( region => region.GKZ == this.selectedRegion.GKZ)
      } else {
        region = this.dataHessen.find( data => data.Jahr == this.year )
      }
      // console.log(region)

      // let result = this.sortParties(region, 10, true).filter( party => party.sitze > 0 )
      let result = this.sortParties(region)
      // console.log(result)

      return {
        cols: result,
        rows: [ result.map( party => party.sitze) ]
      }
    },
    stimmenverteilungenKreise () {
      let kreise = this.dataLandkreise2021.map( landkreis => {
        
        let result = this.sortParties(landkreis, 10, false, this.dataLandkreise2016.find(gemeindeOld => gemeindeOld.GKZ == landkreis.GKZ))

        return {
          title: landkreis.Gemeinde,
          gkz: landkreis.GKZ,
          auszaehlungsstand: landkreis.Auszaehlungsstand,
          cols: result,
          rows: [ result.map( party => party.percent) ]
        }
      })

      let staedte = this.dataGemeinden2021
        .filter( gemeinde => this.kreisfreieStaedte.indexOf(gemeinde.GKZ) >= 0)
        .map( landkreis => {
        
          let result = this.sortParties(landkreis, 10, false, this.dataGemeinden2016.find(gemeindeOld => gemeindeOld.GKZ == landkreis.GKZ))

          return {
            title: landkreis.Gemeinde,
            gkz: landkreis.GKZ,
            auszaehlungsstand: landkreis.Auszaehlungsstand,
            cols: result,
            rows: [ result.map( party => party.percent) ]
          }
        })

      return [...kreise, ...staedte]
    },
    stimmenverteilungenKreise2 () {
      return this.kreise.map( id => {
        let region = id<1000 ? 
          this.dataLandkreise2021.find( region => region.GKZ == String(id))
          : this.dataGemeinden2021.find( region => region.GKZ == String(id))
        
        let regionOld = id<1000 ? 
          this.dataLandkreise2016.find( region => region.GKZ == String(id))
          : this.dataGemeinden2016.find( region => region.GKZ == String(id))

        let result = this.sortParties(region, 7, true, regionOld)

        return {
          title: region.Gemeinde,
          gkz: region.GKZ,
          auszaehlungsstand: region.Auszaehlungsstand,
          cols: result,
          rows: [ result.map( party => party.percent) ]
        }
      })
    },
    stimmenverteilungenGemeinden () {
      return this.dataGemeinden2021
        .filter( gemeinde => this.rheinMain.indexOf(gemeinde.GKZ.slice(0,3)) >= 0 )
        .map( gemeinde => {
        
          let result = this.sortParties(gemeinde, 6, false, this.dataGemeinden2016.find(gemeindeOld => gemeindeOld.GKZ == gemeinde.GKZ))

          return {
            title: gemeinde.Gemeinde,
            gkz: gemeinde.GKZ,
            cols: result,
            rows: [ result.map( party => party.percent) ]
          }
        })
    },
    rheinMainKreise () {
      return this.stimmenverteilungenKreise.filter( kreis => {
        return this.rheinMain.indexOf(kreis.gkz) >= 0
      }).sort( (a, b) => b.title.replace("Landkreis ","") - a.title.replace("Landkreis ",""))
    },
  },
  methods: {
    sortParties (region, max, others, regionOld) {
      let maxParties = max ? max : 10

      let result = this.parties2021.map( party => {
        return {
          label: region[party.id+'-Name'] ? region[party.id+'-Name']: party.label,
          id: party.id, //region[party.id+'-Name'] == 'FW' ? 'FREIE WÄHLER' : 
          color: party.color,
          percent: region[party.id],
          sitze: region[party.id+"-Sitze"],
          percentOld: regionOld ? regionOld[party.id]: 0,
          diff: regionOld ? Math.round((region[party.id]-regionOld[party.id])*10)/10 : 0
        }
      })
      .filter( a => a.percent > 1)
      .sort( (a, b) => b.percent - a.percent)
      .slice(0, others ? maxParties : maxParties-1)
      
      if (!others) { return result }

      let sonstigeProzent = 100 - result.reduce( (a, b) => { return a + b.percent },0)
      let sonstigeSitze = parseInt(region.Sitze) - result.reduce( (a, b) => { return a + b.sitze },0)

      if (result.length>0&&sonstigeProzent>=1) {
        sonstigeProzent = Math.round(sonstigeProzent*10)/10
        sonstigeProzent = Math.max(sonstigeProzent, 0)
        result.push( {
          label: "Sonst.",
          color: "#ddd",
          percent: sonstigeProzent,
          sitze: sonstigeSitze
        })
      }

      return result
    },
    removeFirstLine (string) {
      let lines = string.split('\n')
      lines.splice(0,1)
      return lines.join('\n')
    },
    calculatePercentages (array) {
      return array.map( region => {
        // console.log(region)
        this.parties2021.forEach( party => {
          let percent = 0
          percent = parseFloat(region[party.id]) / parseFloat(region['gültige Stimmen'])
          percent = Math.round(percent*1000)/10
          region[party.id] = percent
          // console.log(percent)
        })
        // console.log(region)
        return region
      })
    },
    parseCsv (csv) {
      return csvParse(csv)
    },
    parseDsv (csv) {
      let dsv = d3.dsvFormat(";")
      return dsv.parse(csv)
    },
    parse2016 (csv) {
      let dsv = d3.dsvFormat(";")
      return dsv.parse(csv, region => {
        if(region.Gemeinde=="3") { return }
        this.parties2021.forEach( party => {
          if(!region[party.id]) { return }
          region[party.id] = parseFloat(region[party.id].replace(',','.'))
          region[party.id+"-Sitze"] = parseInt(region[party.id+"-Sitze"])
        })

        let wahlbeteiligung = parseFloat(region['Wählerinnen und Wähler'])/parseFloat(region['Wahlberechtigte insgesamt'])
        if (region.Wahlbeteiligung) {
          region.Wahlbeteiligung = parseFloat(region.Wahlbeteiligung.replace(',','.'))
        } else {
          region.Wahlbeteiligung = Math.round(wahlbeteiligung*1000)/10
        }
        
        let auszaehlungsstand = 1 - parseFloat(region['Noch nicht ausgewertet'])/parseFloat(region['Wählerinnen und Wähler'])
        region.Auszaehlungsstand = Math.round(auszaehlungsstand*1000)/10

        region.Gemeinde = region.Gemeinde.split(',')[0]
        
        return region
      })
    },
    parse2021 (csv) {
      let dsv = d3.dsvFormat(";")
      return dsv.parse(csv, region => {
        if(region.Gemeinde=="3") { return }
        this.parties2021.forEach( party => {
          if(!region[party.id]) { return }
          let percent = 0
          percent = parseFloat(region[party.id]) / parseFloat(region['gültige Stimmen'])
          percent = Math.round(percent*1000)/10
          region[party.id] = percent
          region[party.id+"-Sitze"] = parseInt(region[party.id+"-Sitze"])
        })    
        let wahlbeteiligung = parseFloat(region['Wählerinnen und Wähler'])/parseFloat(region['Wahlberechtigte insgesamt'])
        region.Wahlbeteiligung = Math.round(wahlbeteiligung*1000)/10
        region.Gemeinde = region.Gemeinde.split(',')[0]

        return region
      })
    },
    addKFS (kreise, year) {
      let staedte = this['dataGemeinden'+year]
        .filter( gemeinde => this.kreisfreieStaedte.indexOf(gemeinde.GKZ) >= 0)
        .map( gemeinde => {
          let clone = JSON.parse(JSON.stringify(gemeinde))
          clone.GKZ = gemeinde.GKZ.slice(0,3)
          return clone
        })

      return [...staedte, ...kreise]
    },
    select () {
      // this.hover = 42
      // this.activeRegion = this.selectedRegion
    },
  },
  mounted () {
    this.stage = document.getElementById("app-settings").dataset.stage
    this.date = document.getElementById("app-settings").dataset.date
    let fetches = [
      fetch(process.env.BASE_URL + 'data/gemeinden_hessen_simplify200.geojson').then(r => r.json()),
      fetch(process.env.BASE_URL + 'data/landkreise_hessen_simplify200.geojson').then(r => r.json()),
      fetch(process.env.BASE_URL + 'data/Gemeindewahlen_2016.csv').then(r => r.text()),
      fetch(process.env.BASE_URL + 'data/Kreiswahlen_2016.csv').then(r => r.text()),
      fetch(process.env.BASE_URL + 'data/'+this.stage+'wahlergebnissegemeindewahl.csv').then(r => r.text()),
      fetch(process.env.BASE_URL + 'data/'+this.stage+'wahlergebnissekreiswahl.csv').then(r => r.text()),
      fetch(process.env.BASE_URL + 'data/kommunalwahl.csv').then(r => r.text()),
    ]
    Promise.all(fetches).then((results) => {
      this.gemeindenMap = results[0]
      this.kreiseMap = results[1]
      this.dataGemeinden2016 = this.parse2016(results[2])
      this.dataLandkreise2016 = this.addKFS(this.parse2016(results[3]),'2016')
      if(this.stage != 'empty') {
        if (this.stage == 'trend') {
          this.dataGemeinden2021 = this.parse2016(this.removeFirstLine(results[4]))
          this.dataLandkreise2021 = this.addKFS(this.parse2016(this.removeFirstLine(results[5])),'2021')
        } else {
          this.dataGemeinden2021 = this.parse2021(this.removeFirstLine(results[4]))
          this.dataLandkreise2021 = this.addKFS(this.parse2021(this.removeFirstLine(results[5])),'2021')
        }
      }
      this.dataHessen = this.parse2016(results[6])
      this.loaded = true
    })
  }
}
</script>

<style scoped src="./assets/foundation.css">
</style>

<style scoped lang="scss">
@import './assets/reset.scss';
@import './assets/vue-multiselect.min.css';
@import './assets/fonts.scss';
@import './assets/style.scss';
</style>

<style>
.multiselect__single {
  color: #999;
}

.multiselect__tags {
  border-color: #ddd;
}

.multiselect__select {
  background-image: url("./assets/icons/suche-19-x-20.svg");
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: 50%;
}
.multiselect__select:before {
  display: none;
}
.multiselect--active .multiselect__select {
  transform: none;
  opacity: 0;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: inherit;
}
.multiselect__tags {
  padding: 8px 40px 0 15px;
}
</style>